import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type {
  IxcFundingV1TransferCreateRequestSpec,
  IxcFundingV1TransferType,
  IxcFundingV1TransferTypeOneOfValue,
} from '@interxfi/types/generated/api';
import { getOneOfType } from '@interxfi/types/helpers/one-of';

const labelsWithoutPrefix: Record<IxcFundingV1TransferTypeOneOfValue, string> = {
  achPush: 'Push',
  achPull: 'Pull',
  wirePush: 'Push',
  incomingTransfer: 'Incoming',
};

const variantByType: Record<IxcFundingV1TransferTypeOneOfValue, PillVariant> = {
  achPush: 'danger',
  achPull: 'green',
  wirePush: 'danger',
  incomingTransfer: 'green',
};

interface FundingTransferTypePillProps extends Omit<PillProps, 'children' | 'variant'> {
  type:
    | IxcFundingV1TransferType
    | IxcFundingV1TransferCreateRequestSpec
    | (IxcFundingV1TransferType | IxcFundingV1TransferCreateRequestSpec)['!type']
    | undefined;
  withoutTypePrefix?: boolean;
}

export function FundingTransferTypePill({ isPending, type: t, withoutTypePrefix, ...props }: FundingTransferTypePillProps) {
  const oneOfValue = typeof t === 'string' ? t : getOneOfType(t);

  return (
    <Pill isPending={!oneOfValue || isPending} {...props} variant={(oneOfValue ? variantByType[oneOfValue] : undefined) ?? 'neutral'}>
      {withoutTypePrefix && oneOfValue ? (
        labelsWithoutPrefix[oneOfValue]
      ) : (
        <TranslatedText defaultValue={oneOfValue} i18nKey={{ namespace: 'ixcFundingV1', oneOfName: 'IxcFundingV1TransferType', value: oneOfValue }} />
      )}
    </Pill>
  );
}
